<template>
  <div class="ListHeader">
    <list-meta v-bind="$attrs" v-on="$listeners">
      <template v-if="$slots.center" v-slot:center>
        <slot name="center"></slot>
      </template>
      <el-select
        class="ListHeader-sort"
        v-if="sortPropertiesArray.length > 1"
        :value="sort"
        @input="sortChanged"
        :placeholder="$t('components.lists.sortByPlaceholder')"
      >
        <el-option
          v-for="{ value, label } in sortPropertiesArray"
          :key="value"
          :value="value"
          :label="$t('components.lists.sortByLabel', { label })"
        ></el-option>
      </el-select>
      <template v-else-if="sortPropertiesArray.length === 1">{{
        $t("components.lists.sortByLabel", { label: sort })
      }}</template>
    </list-meta>
    <hr class="ListHeader-separator" />
  </div>
</template>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.ListHeader {
  & + * {
    @extend .mt-4;
  }

  &-separator {
    @extend .mb-0, .mt-4;
  }
  &-sort {
    width: auto !important;
  }

  @include media-breakpoint-down(sm) {
    &-separator {
      margin-top: map-get($spacers, 3) !important;
    }
  }
}
</style>

<script>
import ListMeta from './ListMeta'

/**
 * En-tête de liste, incluant la pagination et les tris
 */
export default {
  name: 'UbiListHeader',
  components: {
    ListMeta
  },
  props: {
    /**
     * Prioriétés des tris
     */
    sortProperties: { type: Object, default: null },
    /**
     * Tri sélectionné
     */
    sort: { type: String, default: '' }
  },
  computed: {
    sortPropertiesArray () {
      return Object.keys(this.sortProperties || {}).map(value => ({
        value,
        label: this.sortProperties[value]
      }))
    }
  },
  methods: {
    sortChanged (newSort) {
      this.$emit('update:sort', newSort)
      this.$emit('input')
    }
  }
}
</script>
